import { type TargetWidgetData } from '@terros/common'
import { getMetricDataTarget } from '../util'
import { type WidgetDisplayData } from './types'

export const toValidPercentage = (value: number, goal: number): number => {
  if (goal === 0) return 0
  return (value / goal) * 100
}

export const toWidgetDisplayData = (widgetData: TargetWidgetData): WidgetDisplayData => {
  const goal = getMetricDataTarget(widgetData)
  const percentage = toValidPercentage(widgetData.value, goal)
  const quartile = widgetData.quartile ?? percentage
  return {
    ...widgetData,
    percentage,
    quartile,
    goal,
  }
}
